import { render } from "./CorporateCompanyInfo.vue?vue&type=template&id=94e9d9be&scoped=true"
const script = {}

import "./CorporateCompanyInfo.vue?vue&type=style&index=0&id=94e9d9be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e9d9be"]])

export default __exports__